
import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

const RelatedLinks = () => {
  const internalLinks = [
    { title: "DeepSeek V3.1: New AI Frontier", path: "/blog/deepseek-v31" },
    { title: "What is Deep Seek?", path: "/blog/what-is-deep-seek" },
    { title: "Deep Learning AI Explained", path: "/blog/what-is-deep-learning-ai" },
    { title: "Deep Seek R2 Challenges", path: "/blog/deepseek-r2-challenges" },
    { title: "Deep Seek R1 Advanced AI Model", path: "/deepseek-r1" },
    { title: "DeepSeek vs Stepfun: Reasoning vs Multimodal", path: "/deepseek-vs-stepfun" },
  ];

  const externalLinks = [
    { title: "Stanford AI Lab Research", url: "https://ai.stanford.edu/research/" },
    { title: "MIT Technology Review", url: "https://www.technologyreview.com/topic/artificial-intelligence/" },
    { title: "AI & ML Papers at arXiv", url: "https://arxiv.org/list/cs.AI/recent" },
    { title: "Google AI Research", url: "https://ai.google/research/" },
    { title: "IEEE Spectrum: AI Topics", url: "https://spectrum.ieee.org/topic/artificial-intelligence/" },
  ];

  return (
    <div className="grid md:grid-cols-2 gap-8">
      <div>
        <h3 className="text-xl font-semibold mb-4">Explore Our Content</h3>
        <ul className="space-y-3">
          {internalLinks.map((link, index) => (
            <li key={index}>
              <Link 
                to={link.path} 
                className="text-blue-600 hover:text-blue-800 hover:underline flex items-center"
              >
                {link.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      
      <div>
        <h3 className="text-xl font-semibold mb-4">Authoritative Resources</h3>
        <ul className="space-y-3">
          {externalLinks.map((link, index) => (
            <li key={index}>
              <a 
                href={link.url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-600 hover:text-blue-800 hover:underline flex items-center"
              >
                {link.title}
                <ExternalLink className="h-4 w-4 ml-1" />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RelatedLinks;
